export const engagementAppGroupIdInfobipKakaoSenderKeysData =
  "/engagement/:app_group_id/infobip_kakao_sender_keys_data";
